import React from 'react';
import { Link } from 'react-router-dom';

const AboutUsSection = () => {
    return (
        <section className="AboutSection padd-30">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="commanHead">
                            <h1></h1>
                        </div>
                    </div>
                </div>
                <div className="row text-center">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="icnOuter">
                            <img
                                src="../../assets/images/icon/concrete-mixer.png"
                                title="RMC"
                                alt="RMC"
                                className="span3 wow pulse"
                                style={{
                                    visibility: 'visible',
                                    animationDuration: '0.15s',
                                    animationIterationCount: 5,
                                    animationName: 'pulse'
                                }}
                            />
                        </div>
                        <p className="tagline">
                            Adber Infra India Pvt. Ltd. An ISO 9001:2015 Certified Company
                        </p>
                        <p>
                            Adber Infra India Pvt. Ltd. have established easy solutions of
                            Captive RMC Plants on site to provide economical and low cost in
                            construction for the clients and also various Commercial plants in
                            and around Maharashtra. Being a highly effective, lean and
                            fast-moving organization, we are highly instrumental in providing
                            an extensive array of Ready Mix Concrete. The offered concrete is
                            processed using the finest quality raw material and ultra-modern
                            technology in adherence with industry norms. Our provided mix
                            concrete is tested on varied parameters of quality so as to offer
                            a pure grade to our clients.
                        </p>
                        <Link
                            to="/about-us"
                            className="popart-btn"
                            data-form="order-form"
                            data-btn-type="open-form"
                        >
                            Read More
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

const NumberSection = () => {
    return (
        <section className="numberSection padd-30">
            <div className="container">
                <div className="row"></div>
                <div className="row" id="counter">
                    <div
                        className="col-md-3 col-sm-6 col-xs-12 wow fadeInUp animated"
                        data-wow-delay="0.2s"
                        style={{
                            visibility: 'visible',
                            animationDelay: '0.2s',
                            animationName: 'fadeInUp'
                        }}
                    >
                        <div className="numberBox grn">
                            <div id="shiva">
                                <span className="count grn"> 190860 </span> M<sup>3</sup>+
                            </div>
                            <h2> Concrete Production Till Date </h2>
                        </div>
                    </div>
                    <div
                        className="col-md-3 col-sm-6 col-xs-12 wow fadeInUp animated"
                        data-wow-delay="0.4s"
                        style={{
                            visibility: 'visible',
                            animationDelay: '0.4s',
                            animationName: 'fadeInUp'
                        }}
                    >
                        <div className="numberBox pink">
                            <div id="shiva">
                                <span className="count"> 650 </span> +
                            </div>
                            <h2> Total Number of Slab Concrete Provider </h2>
                        </div>
                    </div>
                    <div
                        className="col-md-3 col-sm-6 col-xs-12 wow fadeInUp animated"
                        data-wow-delay="0.6s"
                        style={{
                            visibility: 'visible',
                            animationDelay: '0.6s',
                            animationName: 'fadeInUp'
                        }}
                    >
                        <div className="numberBox orange">
                            <div id="shiva">
                                <span className="count"> 250 </span> Km+
                            </div>
                            <h2> Total Development of Roads </h2>
                        </div>
                    </div>
                    <div
                        className="col-md-3 col-sm-6 col-xs-12 wow fadeInUp animated"
                        data-wow-delay="0.8s"
                        style={{
                            visibility: 'visible',
                            animationDelay: '0.8s',
                            animationName: 'fadeInUp'
                        }}
                    >
                        <div className="numberBox prpl">
                            <div id="shiva">
                                <span className="count"> 200 </span> +
                            </div>
                            <h2> Number of Projects </h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const AboutUsComponent = () => {
    return (
        <div>
            <AboutUsSection />
            <NumberSection />
        </div>
    );
};

export default AboutUsComponent;
